import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Spinner,
    Alert,
    Card,
    CardBody,
    CardTitle,
    CardLink,
    CardText,
    ListGroup,
    ListGroupItem,
    Row,
    Col,
} from 'reactstrap';

import {
    getFile as onGetFile,
    downloadFile as onDownloadFile,
    getDataResiduesStatement as onDownloadDataResiduesStatement
} from '../../../../slices/thunks';

import { toast } from 'react-toastify';

import { generateExcelStatement } from '../Helpers/generateExcelStatement'

const CardFileStatement = ({ icon, name, detail, handleDownloadFile, data }) => {
    return (
        <React.Fragment>
            <Card className='border'>
                <CardBody>
                    <Row>
                        <Col md={2}>
                            <i className={`${icon} ri-3x`}></i>
                        </Col>
                        <Col>
                            <CardTitle tag="h5" className='mt-2'>{name}</CardTitle>
                            <CardText>{detail}</CardText>
                        </Col>
                    </Row>
                </CardBody>
                <CardBody>
                    <button className='btn btn-primary btn-sm' onClick={() => {
                        console.log(data)
                        handleDownloadFile(data)
                    }}>
                        <i className="icon-download ri-lg px-1"></i>
                        Descargar
                    </button>
                </CardBody>
            </Card>
        </React.Fragment>
    );
}

const FilesStatementModal = ({ data, isOpen, handleToggleModal }) => {
    const dispatch = useDispatch();

    const [fileDownloadLoading, setFileDownloadLoading] = useState(null);

    return (
        <div>
            <Modal
                isOpen={isOpen}
                toggle={() => handleToggleModal()}
                size='lg'
                className='border-0'
                modalClassName='modal fade zoomIn'
                backdrop={'static'}
                centered={true}
            >
                <ModalHeader toggle={handleToggleModal}>Documentos de declaración</ModalHeader>
                <ModalBody className=''>
                    <Row>
                        <Col>
                            <CardFileStatement
                                icon={'ri-file-excel-2-line'}
                                name={'Planilla de Declaración SINADER'}
                                data={data}
                                detail={`Declaración creada el ${String(new Date(data.creation_date).getDay()).padStart(2, '0')}-${String(new Date(data.creation_date).getMonth()).padStart(2, '0')}-${String(new Date(data.creation_date).getFullYear())}`}
                                handleDownloadFile={() => {
                                    dispatch(onDownloadDataResiduesStatement(data._id))
                                        .then(dataResiduesStatement => {
                                            generateExcelStatement(data, dataResiduesStatement.payload);
                                        })
                                }}
                            />
                        </Col>
                        {(data.document_statement_id ?
                            <Col>
                                <CardFileStatement
                                    icon={'ri-file-3-line'}
                                    name={'Certificado de Declaración SINADER'}
                                    detail={`Declarado el ${String(new Date(data.date_document_statement).getDay()).padStart(2, '0')}-${String(new Date(data.date_document_statement).getMonth()).padStart(2, '0')}-${String(new Date(data.date_document_statement).getFullYear())}`}
                                    handleDownloadFile={() => {
                                        toast.info('Preparando la descarga del documento.', { autoClose: 3000 });
                                        setFileDownloadLoading(data.document_statement_id);
                                        dispatch(onGetFile(data.document_statement_id))
                                            .then((data) => {
                                                const file = data.payload;
                                                dispatch(
                                                    onDownloadFile({
                                                        file_id: file._id,
                                                    })
                                                )
                                                    .then(data => {
                                                        const payload = data.payload;
                                                        const url =
                                                            window.URL.createObjectURL(payload);
                                                        const link = document.createElement('a');
                                                        link.href = url;
                                                        link.setAttribute(
                                                            'download',
                                                            `${file.filename}${file.extension}`
                                                        );
                                                        document.body.appendChild(link);
                                                        link.click();
                                                    })
                                                    .finally(() => setFileDownloadLoading(null));
                                            })
                                    }}
                                />
                            </Col>
                            :
                            null
                        )}
                    </Row>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default FilesStatementModal;